/* eslint-disable */
import Vue from "vue";

let baseUrl = "/apiv1/hr/organization";

/**
 * 获取组织架构类型
 * @param {} params
 */
export const getOrgType = params => {
  return Vue.fetch.post(`${baseUrl}/findOrgTypeName`, params);
};

/**
 *获取组织架构树
 */
export const getOrgStructure = params => {
  return Vue.fetch.post(`${baseUrl}/findOrganizationTree`, params);
};

/***
 * 添加组织架构类型
 */
export const addOrgType = params => {
  return Vue.fetch.post(`${baseUrl}/createOrgType`, params);
};

/***
 *更新组织架构类型
 */
export const updateOrgType = params => {
  return Vue.fetch.post(`${baseUrl}/updateOrgType`, params);
};

/***
 *删除组织架构类型
 */
export const deleteOrgType = params => {
  return Vue.fetch.post(`${baseUrl}/deleteOrgType`, params);
};

/***
 *添加组织架构
 */
export const addOrg = params => {
  return Vue.fetch.post(`${baseUrl}/create`, params);
};

/***
 *更新组织架构
 */
export const updateOrg = params => {
  return Vue.fetch.post(`${baseUrl}/update`, params);
};

/***
 *添加组织架构
 */
export const deleteOrg = params => {
  return Vue.fetch.post(`${baseUrl}/delete`, params);
};



// WEBPACK FOOTER //
// ./src/services/enterpriseApi.js